module.exports = __webpack_public_path__ + "img/crm-4.f177df7f.png";